<template>
  <section class="section screencast has-background-zebra-blue">
    <div class="container">
      <h3 class="title is-4 mb-6 has-text-centered has-text-weight-bold">
        {{ title }}
      </h3>
      <div class="columns is-vcentered">
        <div class="column is-fullwidth is-3-tablet" />
        <div class="column is-fullwidth is-6-tablet has-text-centered">
          <div v-if="video" class="video-container">
            <VuepalRemoteVideo v-slot="{ embedUrl }" :url="video?.url">
              <figure class="screencast-video-frame">
                <iframe
                  v-if="embedUrl"
                  :src="embedUrl"
                  allow="encrypted-media; picture-in-picture"
                  allowfullscreen
                />
              </figure>
            </VuepalRemoteVideo>
          </div>
          <div
            v-if="text"
            class="content has-text-weight-semibold is-size-6"
            v-html="text"
          />
        </div>
        <div
          class="column is-fullwidth is-3-tablet has-text-centered has-text-left-desktop"
        >
          <template v-if="features?.length && features?.length > 0">
            <div
              v-for="(feature, index) in features"
              :key="index"
              class="feature"
            >
              <template v-if="feature">
                <MediaSvgIcon
                  v-if="feature.icon"
                  v-bind="feature.icon"
                  class="image-icon"
                />
                <h4 class="title is-6 has-text-weight-bold">
                  {{ feature.title }}
                </h4>
                <p>{{ feature.text }}</p>
              </template>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { ParagraphScreencastVideoFragment } from '#graphql-operations'

defineProps<ParagraphScreencastVideoFragment>()

defineBlokkli({
  bundle: 'frontend_screencast_videos',
  propsFieldMapping: {
    features: { type: 'field', name: 'field_features_list' },
  },
})
</script>

<style lang="scss">
// Height as % of width for the frame (legacy “is-iphone” ratio; taller/narrower than 9:16).
// If Vimeo still shows side bars, lower this (e.g. 190%) for a wider/shorter frame; raise for narrower/taller.
$screencast-frame-height-pct: 217%;

.screencast {
  .video-container {
    width: 100%;
    max-width: 250px;
    margin: 0 auto 3rem;
    box-shadow: 0 12px 32px -8px rgba(26, 26, 26, 0.7);

    @include tablet {
      max-width: 300px;
    }

    .screencast-video-frame {
      position: relative;
      display: block;
      margin: 0;
      width: 100%;
      height: 0;
      padding-top: $screencast-frame-height-pct;
      overflow: hidden;

      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
      }
    }
  }

  //.plyr--video {
  //  max-width: 300px;
  //  margin: 0 auto;
  //  box-shadow: 0 12px 32px -8px rgba(26, 26, 26, 0.7);
  //  margin-bottom: 3rem;
  //}

  &:nth-child(odd) {
    background-color: $sky-blue-8;
  }
  padding: 2rem 0;

  .feature {
    &:nth-child(odd) {
      padding-bottom: 3rem;
    }
    .image-icon {
      padding: 0 0.25rem;

      svg {
        width: 35px;
        height: 35px;
      }

      @include tablet {
        margin-top: 0;
        svg {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
}
</style>
